import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from './data';
const ITEMS = [{
  src: IMAGES.frontyard,
  caption: 'Front yard turf, pavers & lighting',
  span: 'lg:col-span-2 lg:row-span-2'
}, {
  src: IMAGES.pergola,
  caption: 'Backyard turf & shade pergola',
  span: ''
}, {
  src: IMAGES.patio,
  caption: 'Paver patio with turf border',
  span: ''
}, {
  src: IMAGES.planting,
  caption: 'Desert planting & palm install',
  span: 'lg:col-span-2'
}];
export function Gallery() {
  return <section id="gallery" className="w-full bg-background py-20 sm:py-24" data-id="element-84" data-mp="c8ldr154p73d">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-85" data-mp="q7tgg40i2xcb">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-86" data-mp="q9eaztmtega6">
          <div className="max-w-2xl" data-id="element-87" data-mp="l7ymtspcbtnk">
            <span className="text-sm font-semibold uppercase tracking-wider text-brand-red" data-id="element-88" data-mp="lb2ytc91rtos">
              Our work
            </span>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl" data-id="element-89" data-mp="1woonkwazvt9s">
              Recent projects
            </h2>
          </div>
          <p className="text-muted-foreground sm:max-w-xs sm:text-right" data-id="element-90" data-mp="3f8qzl8nh1ubt">
            A look at recent turf, paver, and landscape transformations across the Valley.
          </p>
        </div>

        <div className="mt-12 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-91" data-mp="3p6x13p5d8yg5">
          {ITEMS.map((item, i) => <motion.figure key={item.caption} initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className={`group relative overflow-hidden rounded-2xl ${item.span}`} data-id="element-92" data-mp="2rk7t8ynzfrmd" data-mpi={i}>
              <img src={item.src} alt={item.caption} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-93" data-mp="28t6sc53axm06" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100" data-id="element-94" data-mp="25q0pj4az9n0g" />
              <figcaption className="absolute bottom-0 left-0 right-0 translate-y-2 p-4 text-sm font-medium text-white opacity-0 transition-all group-hover:translate-y-0 group-hover:opacity-100" data-id="element-95" data-mp="2fgly9kkd87x3">
                {item.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}